import { FuelCard } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const ContentHeader = styled.div`
  padding: ${({ theme }) => theme.spacing.km6};
`
export const Card = styled(FuelCard)`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
  border-radius: ${({ theme }) => theme.border.radius.default};
  border: 1px solid ${({ theme }) => theme.color.border.neutral.default};
`

export const MobilePlans = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Span = styled.span<{ alignCenter?: boolean }>`
  display: flex;
  align-items: ${({ alignCenter }) => (alignCenter ? 'center' : 'baseline')};
  gap: ${({ theme }) => theme.spacing.km4};
  flex-wrap: nowrap;

  padding: ${({ alignCenter, theme }) => (alignCenter ? theme.spacing.km4 : '')};

  &&& .typography {
    display: flex;
    gap: ${({ theme }) => theme.spacing.km1};
  }
`
export const ContentAccordion = styled.div`
  display: flex;
  flex-flow: column;
  align-items: baseline;
`
